module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"prop-header\"><span class=\"prop-label\">Mandatory</span></div>\r\n<div class=\"row\">\r\n    <div class=\"col-md-8 prop-sublabel form-group-flex\">\r\n        <input type=\"checkbox\" name=\"isMandatory\" ")
    ; __append(escapeFn((isMandatory) ? 'checked="checked"' : ''))
    ; __append(" class=\"form-radio-group\"> \r\n        <label class=\"form-group-label\">Mandatory Answer</label>\r\n    </div>\r\n    <div class=\"col-md-4 nopadding\" style=\"text-align: right;\">\r\n        <button id=\"mandatoryState\" class=\"btn btn-default hvr-glow button-selector\">...</button>\r\n    </div>\r\n</div>\r\n<div class=\"row\">\r\n    <div class=\"col-md-12\" style=\"padding-right: 0;\">\r\n        <input type=\"text\" name=\"obligatoryMessage\" class=\"")
    ; __append(escapeFn( (isMandatory && obligatoryMessage !== '') ? 'translatable' : ''))
    ; __append("\" data-attr=\"obligatoryMessage\" value=\"")
    ; __append(escapeFn( obligatoryMessage ))
    ; __append("\" ")
    ; __append(escapeFn( (isMandatory) ? '' : 'disabled'))
    ; __append("/>\r\n    </div>\r\n</div>")
  }
  return __output;

}